<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="(type === 'add' ? '新增' : '修改') + '损失费'"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    :append-to-body="true"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '损失类型',
            value: 'lossType',
            type: 'select',
            options: [
              {
                label: '车损',
                value: '1',
              },
              {
                label: '路损',
                value: '2',
              },
              {
                label: '人损',
                value: '3',
              },
              {
                label: '物损',
                value: '4',
              },
            ],
          },
          {
            label: '理赔金额',
            value: 'payAmt',
            type: 'input',
            placeholder: '请输入理赔金额',
          },
          {
            label: '费用说明',
            value: 'payRemark',
            type: 'input',
            placeholder: '请输入费用说明',
            attr: {
              type: 'textarea',
            },
          },
        ],
        rules: { // 表单验证规则
          lossType: [ // 损失类型
            { required: true, message: '请选择损失类型', trigger: 'blur' },
          ],
          payAmt: [ // 理赔金额
            { required: true, message: '请输入理赔金额', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    handleCarChange (data) { // 车辆选择时
      this.setFormAttrVal({
        form: this.formData,
        attr: 'hide',
        value: false,
        names: ['order'],
      });
    },

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$nextTick(() => {
        this.$refs.customForm && this.$refs.customForm.reset();
        this.originData = item;
        if (item) { // 修改
          this.type = 'edit';
          this.$refs.customForm.setVal(item);
          this.handleCarChange();
        } else { // 新增
          this.type = 'add';
        }
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      // 理赔类型
      switch (String(form.lossType)) {
        case '1':
          form.lossTypeName = '车损';
          break;
        case '2':
          form.lossTypeName = '路损';
          break;
        case '3':
          form.lossTypeName = '人损';
          break;
        case '4':
          form.lossTypeName = '物损';
          break;
        default:
          form.lossTypeName = '--';
          break;
      }
      this.$emit('sub', {
        form,
        originData: this.originData,
      });
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
</style>
